{
	"portfolio": {
		"blocks": "Блоки",
		"portfolioValue": "Оценка портфеля, USD",
		"portfolioValuation": "Оценка портфеля",
		"marketValue": "Рын. стоимость",
		"money": "Своб. средства",
		"buyingPowerStocks": "Пок. способн. акций",
		"buyingPowerOptions": "Пок. способн. опционов",
		"profitability": "Доходность",
		"unrealizedPL": "Нереализ. P&L",
		"perDayPL": "P&L за день",
		"riskLevel": "Уровень риска",
		"margin": "MARGIN",
		"call": "CALL",
		"riskLevelsTitles": {
			"low": "Низкий риск",
			"moderate": "Умеренный риск",
			"high": "Высокий риск"
		}
	}
}
